import { defineMessages } from 'react-intl'

export const lang = defineMessages({
    successReceiveTitle: {
        id: 'notifications.deposit.success.receive.title',
        defaultMessage: 'Payment received',
    },
    successReceiveContent: {
        id: 'notifications.deposit.success.receive.content',
        defaultMessage: 'Balance:',
    },
    successBuyTitle: {
        id: 'notifications.deposit.success.buy.title',
        defaultMessage: 'Successful purchase',
    },
    successBuyContent: {
        id: 'notifications.deposit.success.buy.content',
        defaultMessage: 'Balance:',
    },
    pendingBuyTitle: {
        id: 'notifications.deposit.pending.buy.title',
        defaultMessage: 'Purchase is pending',
    },
    pendingBuyContent: {
        id: 'notifications.deposit.pending.buy.content',
        defaultMessage: 'Confirming the buy transaction, please wait.',
    },
    errorBuyTitle: {
        id: 'notifications.deposit.error.buy.title',
        defaultMessage: 'Error purchase',
    },
    errorBuyContent: {
        id: 'notifications.deposit.error.buy.content',
        defaultMessage: 'The purchase transaction cannot be completed.',
    },
    successStakingTitle: {
        id: 'notifications.deposit.success.staking.title',
        defaultMessage: 'Staking reward',
    },
    successStakingContent: {
        id: 'notifications.deposit.success.staking.content',
        defaultMessage: 'Amount:',
    },
    successReferralTitle: {
        id: 'notifications.deposit.success.referral.title',
        defaultMessage: 'Referral reward',
    },
    successReferralContent: {
        id: 'notifications.deposit.success.referral.content',
        defaultMessage: 'Amount:',
    },
    successAirdropTitle: {
        id: 'notifications.deposit.success.airdrop.title',
        defaultMessage: 'Airdrop reward',
    },
    successAirdropContent: {
        id: 'notifications.deposit.success.airdrop.content',
        defaultMessage: 'Amount:',
    },
    messageContent: {
        id: 'notifications.deposit.success.message.content',
        defaultMessage: 'Message:',
    },
    errorTitle: {
        id: 'notifications.deposit.error.title',
        defaultMessage: 'Error!',
    },
    forbiddenApiError: {
        id: 'notifications.deposit.error.forbidden.api',
        defaultMessage: 'The action was blocked <br/>Please contact support',
    },
    addressGenerateError: {
        id: 'notifications.deposit.error.address.generate',
        defaultMessage: 'Address generation failed',
    },
})
